module.exports = __webpack_public_path__ + "static/img/signUpBg.1fb82a7.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Signup/signUpBg.jpeg
// module id = DLSf
// module chunks = 37